import { render } from "./AirportCard.vue?vue&type=template&id=89b1f620"
import script from "./AirportCard.vue?vue&type=script&lang=js"
export * from "./AirportCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__